/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const client = /* GraphQL */ `query Client($id: ID!) {
  client(id: $id) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.ClientQueryVariables, APITypes.ClientQuery>;
export const resortClient = /* GraphQL */ `query ResortClient($id: ID!) {
  resortClient(id: $id) {
    id
    firstName
    lastName
    phone
    email
    image
    referralSource
    hasShopper
    signupTimestamp
    attnPassword
    deactivated
    hasStreamUser
    preferences {
      id
      surveys {
        id
        completedTimestamp
        name
        responses {
          id
          question
          response
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ResortClientQueryVariables,
  APITypes.ResortClientQuery
>;
export const clientDefaultAddress = /* GraphQL */ `query ClientDefaultAddress($id: ID!) {
  clientDefaultAddress(id: $id) {
    id
    addressName
    addressLine1
    addressLine2
    city
    state
    zipcode
    country
    isDefault
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientDefaultAddressQueryVariables,
  APITypes.ClientDefaultAddressQuery
>;
export const clientAddresses = /* GraphQL */ `query ClientAddresses($count: Int, $nextToken: String) {
  clientAddresses(count: $count, nextToken: $nextToken) {
    addresses {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientAddressesQueryVariables,
  APITypes.ClientAddressesQuery
>;
export const addressSuggest = /* GraphQL */ `query AddressSuggest($query: String!) {
  addressSuggest(query: $query) {
    lat
    lon
    addressLine1
    addressLine2
    city
    state
    zipcode
    country
    freeForm
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AddressSuggestQueryVariables,
  APITypes.AddressSuggestQuery
>;
export const clientPaymentMethods = /* GraphQL */ `query ClientPaymentMethods($count: Int, $nextToken: String) {
  clientPaymentMethods(count: $count, nextToken: $nextToken) {
    paymentMethods {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientPaymentMethodsQueryVariables,
  APITypes.ClientPaymentMethodsQuery
>;
export const clientOrders = /* GraphQL */ `query ClientOrders($count: Int, $nextToken: String) {
  clientOrders(count: $count, nextToken: $nextToken) {
    orders {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      listReferences {
        storeName
        storeImage
        storeId
        id
        listName
        listItemCount
        listVersion
        lastCompletedOrderId
        savedListId
        savedListItemCount
        savedListVersion
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    nextToken
    prevToken
    pageNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientOrdersQueryVariables,
  APITypes.ClientOrdersQuery
>;
export const clientOrdersFiltered = /* GraphQL */ `query ClientOrdersFiltered(
  $orderStatus: String
  $reverse: Boolean
  $count: Int
  $nextToken: String
  $serviceName: String
) {
  clientOrdersFiltered(
    orderStatus: $orderStatus
    reverse: $reverse
    count: $count
    nextToken: $nextToken
    serviceName: $serviceName
  ) {
    orders {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      listReferences {
        storeName
        storeImage
        storeId
        id
        listName
        listItemCount
        listVersion
        lastCompletedOrderId
        savedListId
        savedListItemCount
        savedListVersion
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    nextToken
    prevToken
    pageNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientOrdersFilteredQueryVariables,
  APITypes.ClientOrdersFilteredQuery
>;
export const clientPastOrderLists = /* GraphQL */ `query ClientPastOrderLists(
  $count: Int
  $nextToken: String
  $serviceName: String
) {
  clientPastOrderLists(
    count: $count
    nextToken: $nextToken
    serviceName: $serviceName
  ) {
    pastOrderLists {
      title
      deliveryTimestamp
      categorizedListProducts {
        category
        categoryEmoji
        listProducts {
          id
          catalogId
          media {
            ... on ProductImage {
              imageUrl
            }
            ... on ProductVideo {
              videoUrl
            }
          }
          attributedMedia {
            sourceUrl
            hostPageUrl
            hostPageName
            __typename
          }
          count
          note
          isCustom
          name
          priceCents
          displayPrice
          salePriceCents
          saleDisplayPrice
          position
          category
          categoryEmoji
          displayUnit
          referenceLink
          deleted
          available
          lastUpdatedTimestamp
          shopperNote
          createdByShopperId
          shopperPosition
          shopperCategoryPosition
          shopperCheckedOff
          shopperCheckedOffTimestamp
          shopperNotAvailable
          selectedProductOptions {
            name
            selection
            __typename
          }
          packageLineItems {
            productId
            name
            quantity
            note
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientPastOrderListsQueryVariables,
  APITypes.ClientPastOrderListsQuery
>;
export const clientOrder = /* GraphQL */ `query ClientOrder($clientId: ID!, $orderId: ID!, $orderTimestamp: String!) {
  clientOrder(
    clientId: $clientId
    orderId: $orderId
    orderTimestamp: $orderTimestamp
  ) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientOrderQueryVariables,
  APITypes.ClientOrderQuery
>;
export const allAccessibleOrders = /* GraphQL */ `query AllAccessibleOrders($count: Int, $nextToken: String) {
  allAccessibleOrders(count: $count, nextToken: $nextToken) {
    sharedOrders {
      version
      id
      clientId
      shopperId
      firstName
      lastName
      phone
      email
      clientImage
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllAccessibleOrdersQueryVariables,
  APITypes.AllAccessibleOrdersQuery
>;
export const linkedShopper = /* GraphQL */ `query LinkedShopper($id: ID!) {
  linkedShopper(id: $id) {
    id
    shopper {
      id
      firstName
      lastName
      displayName
      deliveryArea
      websiteUrl
      phone
      businessPhone
      email
      bio
      image
      businessName
      availabilityDescription
      announcement
      rating
      repeatClientCount
      orderCount
      reviewCount
      specialtyTags
      tagline
      metaTitle
      metaImage
      metaDescription
      deliveryAreaZipcode
      deliveryAreaZipcodes
      deliveryRadius
      lowestPrice
      subscriptionPlan
      subscriptionPlanDetails {
        id
        textComponents {
          text
          bold
          __typename
        }
        phases {
          id
          status
          __typename
        }
        __typename
      }
      branding {
        coverColor
        __typename
      }
      typicalPricing {
        summary {
          title
          description
          __typename
        }
        groceries
        shoppingAndDelivery
        minGratuity
        platform
        __typename
      }
      allowClientConnection
      stripeConnectAcctExists
      fullSSNRequired
      attnBizProfile
      attnDirectDeposit
      attnCreditCard
      attnServices
      attnPassword
      statusIdentityVerification {
        state
        message
        externalLink
        __typename
      }
      statusChargeCard {
        state
        message
        externalLink
        __typename
      }
      optInEngage
      optInZipcode
      deactivated
      acceptsReferralNetwork
      __typename
    }
    serviceOfferings {
      id
      serviceName
      serviceImage
      serviceDescription
      defaultErrandBusinessNames
      baseFee
      maxErrands
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      disclaimerText
      useSuggestedPricing
      __typename
    }
    serviceArea {
      id
      city
      state
      zipcode
      description
      __typename
    }
    serviceTimes {
      dayOfWeek
      startTime
      endTime
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedShopperQueryVariables,
  APITypes.LinkedShopperQuery
>;
export const checkCouponCode = /* GraphQL */ `query CheckCouponCode($couponCode: String) {
  checkCouponCode(couponCode: $couponCode) {
    id
    couponCode
    couponValue
    paidByShopper
    validClientIds
    usesPerClient
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckCouponCodeQueryVariables,
  APITypes.CheckCouponCodeQuery
>;
export const shopper = /* GraphQL */ `query Shopper($id: ID!) {
  shopper(id: $id) {
    id
    firstName
    lastName
    displayName
    deliveryArea
    websiteUrl
    phone
    businessPhone
    email
    bio
    image
    businessName
    availabilityDescription
    announcement
    rating
    repeatClientCount
    orderCount
    reviewCount
    specialtyTags
    tagline
    metaTitle
    metaImage
    metaDescription
    deliveryAreaZipcode
    deliveryAreaZipcodes
    deliveryRadius
    lowestPrice
    subscriptionPlan
    subscriptionPlanDetails {
      id
      textComponents {
        text
        bold
        __typename
      }
      phases {
        id
        status
        __typename
      }
      __typename
    }
    branding {
      coverColor
      __typename
    }
    typicalPricing {
      summary {
        title
        description
        __typename
      }
      groceries
      shoppingAndDelivery
      minGratuity
      platform
      __typename
    }
    allowClientConnection
    stripeConnectAcctExists
    fullSSNRequired
    attnBizProfile
    attnDirectDeposit
    attnCreditCard
    attnServices
    attnPassword
    statusIdentityVerification {
      state
      message
      externalLink
      __typename
    }
    statusChargeCard {
      state
      message
      externalLink
      __typename
    }
    optInEngage
    optInZipcode
    deactivated
    acceptsReferralNetwork
    __typename
  }
}
` as GeneratedQuery<APITypes.ShopperQueryVariables, APITypes.ShopperQuery>;
export const shopperIdentity = /* GraphQL */ `query ShopperIdentity {
  shopperIdentity {
    firstName
    lastName
    dob
    phone
    email
    addressLine1
    addressLine2
    city
    state
    zipcode
    ssn
    completed
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperIdentityQueryVariables,
  APITypes.ShopperIdentityQuery
>;
export const shopperBusinessProfile = /* GraphQL */ `query ShopperBusinessProfile($id: ID!) {
  shopperBusinessProfile(id: $id) {
    shopper {
      id
      firstName
      lastName
      displayName
      deliveryArea
      websiteUrl
      phone
      businessPhone
      email
      bio
      image
      businessName
      availabilityDescription
      announcement
      rating
      repeatClientCount
      orderCount
      reviewCount
      specialtyTags
      tagline
      metaTitle
      metaImage
      metaDescription
      deliveryAreaZipcode
      deliveryAreaZipcodes
      deliveryRadius
      lowestPrice
      subscriptionPlan
      subscriptionPlanDetails {
        id
        textComponents {
          text
          bold
          __typename
        }
        phases {
          id
          status
          __typename
        }
        __typename
      }
      branding {
        coverColor
        __typename
      }
      typicalPricing {
        summary {
          title
          description
          __typename
        }
        groceries
        shoppingAndDelivery
        minGratuity
        platform
        __typename
      }
      allowClientConnection
      stripeConnectAcctExists
      fullSSNRequired
      attnBizProfile
      attnDirectDeposit
      attnCreditCard
      attnServices
      attnPassword
      statusIdentityVerification {
        state
        message
        externalLink
        __typename
      }
      statusChargeCard {
        state
        message
        externalLink
        __typename
      }
      optInEngage
      optInZipcode
      deactivated
      acceptsReferralNetwork
      __typename
    }
    serviceOfferings {
      id
      serviceName
      serviceImage
      serviceDescription
      defaultErrandBusinessNames
      baseFee
      maxErrands
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      disclaimerText
      useSuggestedPricing
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperBusinessProfileQueryVariables,
  APITypes.ShopperBusinessProfileQuery
>;
export const chargeCards = /* GraphQL */ `query ChargeCards($count: Int, $nextToken: String) {
  chargeCards(count: $count, nextToken: $nextToken) {
    chargeCards {
      id
      brand
      expirationMonth
      expirationYear
      last4
      status
      message
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChargeCardsQueryVariables,
  APITypes.ChargeCardsQuery
>;
export const shopperSchedule = /* GraphQL */ `query ShopperSchedule($id: ID!) {
  shopperSchedule(id: $id) {
    id
    dailySchedules {
      id
      day
      timeSlots {
        id
        slotStart
        slotEnd
        isActive
        bufferDuration
        bufferMode
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperScheduleQueryVariables,
  APITypes.ShopperScheduleQuery
>;
export const linkedShopperSchedule = /* GraphQL */ `query LinkedShopperSchedule($id: ID!) {
  linkedShopperSchedule(id: $id) {
    id
    dailySchedules {
      id
      day
      timeSlots {
        id
        slotStart
        slotEnd
        isActive
        bufferDuration
        bufferMode
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedShopperScheduleQueryVariables,
  APITypes.LinkedShopperScheduleQuery
>;
export const shopperScheduleV2 = /* GraphQL */ `query ShopperScheduleV2($id: ID) {
  shopperScheduleV2(id: $id) {
    dailySchedules {
      id
      day
      timeSlots {
        id
        slotStart
        slotEnd
        maxOrders
        bufferDuration
        bufferMode
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperScheduleV2QueryVariables,
  APITypes.ShopperScheduleV2Query
>;
export const linkedShopperScheduleV2 = /* GraphQL */ `query LinkedShopperScheduleV2($id: ID) {
  linkedShopperScheduleV2(id: $id) {
    dailySchedules {
      id
      day
      timeSlots {
        id
        slotStart
        slotEnd
        maxOrders
        bufferDuration
        bufferMode
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedShopperScheduleV2QueryVariables,
  APITypes.LinkedShopperScheduleV2Query
>;
export const shopperClosedDateRanges = /* GraphQL */ `query ShopperClosedDateRanges($id: ID, $input: ShopperClosedDateRangesInput!) {
  shopperClosedDateRanges(id: $id, input: $input) {
    closedDateRanges {
      id
      startDate
      endDate
      description
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperClosedDateRangesQueryVariables,
  APITypes.ShopperClosedDateRangesQuery
>;
export const linkedShopperAvailableSchedule = /* GraphQL */ `query LinkedShopperAvailableSchedule(
  $id: ID
  $input: ShopperAvailableScheduleInput!
) {
  linkedShopperAvailableSchedule(id: $id, input: $input) {
    firstAvailableDayIndex
    firstAvailableTimeSlotOfDayIndex
    dailyAvailableSchedules {
      day
      date
      isClosed
      availableTimeSlots {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedShopperAvailableScheduleQueryVariables,
  APITypes.LinkedShopperAvailableScheduleQuery
>;
export const shopperScheduleOptions = /* GraphQL */ `query ShopperScheduleOptions($id: ID) {
  shopperScheduleOptions(id: $id) {
    defaultMaxOrders
    defaultTimeSlotDuration
    isScheduleAvailable
    defaultBufferDuration
    defaultBufferMode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperScheduleOptionsQueryVariables,
  APITypes.ShopperScheduleOptionsQuery
>;
export const serviceArea = /* GraphQL */ `query ServiceArea($id: ID!) {
  serviceArea(id: $id) {
    id
    city
    state
    zipcode
    description
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ServiceAreaQueryVariables,
  APITypes.ServiceAreaQuery
>;
export const serviceTimes = /* GraphQL */ `query ServiceTimes($count: Int, $nextToken: String) {
  serviceTimes(count: $count, nextToken: $nextToken) {
    serviceTimes {
      dayOfWeek
      startTime
      endTime
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ServiceTimesQueryVariables,
  APITypes.ServiceTimesQuery
>;
export const getLinkedClient = /* GraphQL */ `query GetLinkedClient($clientId: ID!) {
  getLinkedClient(clientId: $clientId) {
    id
    client {
      id
      firstName
      lastName
      phone
      email
      image
      referralSource
      hasShopper
      signupTimestamp
      attnPassword
      deactivated
      hasStreamUser
      preferences {
        id
        surveys {
          id
          completedTimestamp
          name
          responses {
            id
            question
            response
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    note
    orderCount
    lastOrderTimestamp
    firstConnectTimestamp
    referralSourceMessage
    clientAnnotation {
      id
      note
      image
      noteLastUpdatedTimestamp
      preferencesLastUpdatedTimestamp
      preferencesLastSeenTimestamp
      needsToSeePreferences
      __typename
    }
    lastInviteTimestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLinkedClientQueryVariables,
  APITypes.GetLinkedClientQuery
>;
export const linkedClients = /* GraphQL */ `query LinkedClients($sortOrder: String, $count: Int, $nextToken: String) {
  linkedClients(sortOrder: $sortOrder, count: $count, nextToken: $nextToken) {
    linkedClients {
      id
      client {
        id
        firstName
        lastName
        phone
        email
        image
        referralSource
        hasShopper
        signupTimestamp
        attnPassword
        deactivated
        hasStreamUser
        preferences {
          id
          surveys {
            id
            completedTimestamp
            name
            __typename
          }
          __typename
        }
        __typename
      }
      note
      orderCount
      lastOrderTimestamp
      firstConnectTimestamp
      referralSourceMessage
      clientAnnotation {
        id
        note
        image
        noteLastUpdatedTimestamp
        preferencesLastUpdatedTimestamp
        preferencesLastSeenTimestamp
        needsToSeePreferences
        __typename
      }
      lastInviteTimestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedClientsQueryVariables,
  APITypes.LinkedClientsQuery
>;
export const filteredLinkedClients = /* GraphQL */ `query FilteredLinkedClients(
  $sort: QuerySortInput
  $filters: [QueryFilterInput!]
  $count: Int
  $nextToken: String
) {
  filteredLinkedClients(
    sort: $sort
    filters: $filters
    count: $count
    nextToken: $nextToken
  ) {
    linkedClients {
      id
      client {
        id
        firstName
        lastName
        phone
        email
        image
        referralSource
        hasShopper
        signupTimestamp
        attnPassword
        deactivated
        hasStreamUser
        preferences {
          id
          surveys {
            id
            completedTimestamp
            name
            __typename
          }
          __typename
        }
        __typename
      }
      note
      orderCount
      lastOrderTimestamp
      firstConnectTimestamp
      referralSourceMessage
      clientAnnotation {
        id
        note
        image
        noteLastUpdatedTimestamp
        preferencesLastUpdatedTimestamp
        preferencesLastSeenTimestamp
        needsToSeePreferences
        __typename
      }
      lastInviteTimestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FilteredLinkedClientsQueryVariables,
  APITypes.FilteredLinkedClientsQuery
>;
export const linkedClientsSortFilterOptions = /* GraphQL */ `query LinkedClientsSortFilterOptions {
  linkedClientsSortFilterOptions {
    sortOptions {
      name
      property
      __typename
    }
    filterOptions {
      name
      property
      type {
        ... on DateRangeFilterType {
          minTimestamp
          maxTimestamp
        }
        ... on IntRangeFilterType {
          minRange
          minValue
          maxRange
          maxValue
        }
        ... on ChoiceFilterType {
          options {
            name
            property
            __typename
          }
          isRadioButton
        }
        ... on BooleanFilterType {
          name
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedClientsSortFilterOptionsQueryVariables,
  APITypes.LinkedClientsSortFilterOptionsQuery
>;
export const linkedClientsSortFilterPresets = /* GraphQL */ `query LinkedClientsSortFilterPresets {
  linkedClientsSortFilterPresets {
    name
    description
    sort {
      property
      direction
      __typename
    }
    filters {
      operator
      property
      values
      __typename
    }
    children {
      name
      description
      sort {
        property
        direction
        __typename
      }
      filters {
        operator
        property
        values
        __typename
      }
      children {
        name
        description
        sort {
          property
          direction
          __typename
        }
        filters {
          operator
          property
          values
          __typename
        }
        children {
          name
          description
          sort {
            property
            direction
            __typename
          }
          filters {
            operator
            property
            values
            __typename
          }
          children {
            name
            description
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedClientsSortFilterPresetsQueryVariables,
  APITypes.LinkedClientsSortFilterPresetsQuery
>;
export const invitedClients = /* GraphQL */ `query InvitedClients($sortOrder: String, $count: Int, $nextToken: String) {
  invitedClients(sortOrder: $sortOrder, count: $count, nextToken: $nextToken) {
    linkedClients {
      id
      client {
        id
        firstName
        lastName
        phone
        email
        image
        referralSource
        hasShopper
        signupTimestamp
        attnPassword
        deactivated
        hasStreamUser
        preferences {
          id
          surveys {
            id
            completedTimestamp
            name
            __typename
          }
          __typename
        }
        __typename
      }
      note
      orderCount
      lastOrderTimestamp
      firstConnectTimestamp
      referralSourceMessage
      clientAnnotation {
        id
        note
        image
        noteLastUpdatedTimestamp
        preferencesLastUpdatedTimestamp
        preferencesLastSeenTimestamp
        needsToSeePreferences
        __typename
      }
      lastInviteTimestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvitedClientsQueryVariables,
  APITypes.InvitedClientsQuery
>;
export const directDepositAccounts = /* GraphQL */ `query DirectDepositAccounts($count: Int, $nextToken: String) {
  directDepositAccounts(count: $count, nextToken: $nextToken) {
    directDepositAccounts {
      id
      bankName
      accountHolderName
      routingNumber
      last4
      error
      isDefault
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DirectDepositAccountsQueryVariables,
  APITypes.DirectDepositAccountsQuery
>;
export const shopperServices = /* GraphQL */ `query ShopperServices($id: ID!) {
  shopperServices(id: $id) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperServicesQueryVariables,
  APITypes.ShopperServicesQuery
>;
export const allPossibleShopperServices = /* GraphQL */ `query AllPossibleShopperServices($id: ID!) {
  allPossibleShopperServices(id: $id) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllPossibleShopperServicesQueryVariables,
  APITypes.AllPossibleShopperServicesQuery
>;
export const usedServiceOfferingsList = /* GraphQL */ `query UsedServiceOfferingsList($id: ID) {
  usedServiceOfferingsList(id: $id) {
    id
    serviceName
    serviceImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsedServiceOfferingsListQueryVariables,
  APITypes.UsedServiceOfferingsListQuery
>;
export const unusedServiceOfferingsList = /* GraphQL */ `query UnusedServiceOfferingsList($id: ID) {
  unusedServiceOfferingsList(id: $id) {
    id
    serviceName
    serviceImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UnusedServiceOfferingsListQueryVariables,
  APITypes.UnusedServiceOfferingsListQuery
>;
export const serviceOffering = /* GraphQL */ `query ServiceOffering($id: ID!, $isNewService: Boolean!) {
  serviceOffering(id: $id, isNewService: $isNewService) {
    id
    serviceName
    serviceImage
    serviceDescription
    defaultErrandBusinessNames
    baseFee
    maxErrands
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    disclaimerText
    useSuggestedPricing
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ServiceOfferingQueryVariables,
  APITypes.ServiceOfferingQuery
>;
export const shopperCoupons = /* GraphQL */ `query ShopperCoupons($count: Int, $nextToken: String) {
  shopperCoupons(count: $count, nextToken: $nextToken) {
    coupons {
      id
      couponCode
      couponValue
      paidByShopper
      validClientIds
      usesPerClient
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperCouponsQueryVariables,
  APITypes.ShopperCouponsQuery
>;
export const linkedOrders = /* GraphQL */ `query LinkedOrders($orderStatus: String, $count: Int, $nextToken: String) {
  linkedOrders(
    orderStatus: $orderStatus
    count: $count
    nextToken: $nextToken
  ) {
    orders {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      listReferences {
        storeName
        storeImage
        storeId
        id
        listName
        listItemCount
        listVersion
        lastCompletedOrderId
        savedListId
        savedListItemCount
        savedListVersion
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    nextToken
    prevToken
    pageNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedOrdersQueryVariables,
  APITypes.LinkedOrdersQuery
>;
export const filteredLinkedOrders = /* GraphQL */ `query FilteredLinkedOrders(
  $sort: QuerySortInput
  $filters: [QueryFilterInput!]
  $text: String
  $count: Int
  $nextToken: String
) {
  filteredLinkedOrders(
    sort: $sort
    filters: $filters
    text: $text
    count: $count
    nextToken: $nextToken
  ) {
    orders {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    nextToken
    prevToken
    pageNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FilteredLinkedOrdersQueryVariables,
  APITypes.FilteredLinkedOrdersQuery
>;
export const linkedOrder = /* GraphQL */ `query LinkedOrder($id: ID!, $deliveryTimestamp: String!) {
  linkedOrder(id: $id, deliveryTimestamp: $deliveryTimestamp) {
    version
    id
    clientId
    shopperId
    shopperInfo {
      image
      displayName
      email
      __typename
    }
    firstName
    lastName
    phone
    email
    clientImage
    note
    privateNote
    adminNote
    conciergeNote
    orderStatus
    orderDateTime
    orderTimestamp
    deliveryDate
    deliveryTime
    deliveryTimestamp
    deliveryStartDateTime
    deliveryEndDateTime
    deliveryAddress {
      id
      addressName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      isDefault
      __typename
    }
    orderPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    serviceRequestList {
      serviceId
      serviceName
      image
      errandList {
        businessName
        shoppingItemCount
        shoppingList {
          id
          itemName
          itemNote
          isDone
          __typename
        }
        __typename
      }
      __typename
    }
    pricingModel {
      version
      description
      flatPm {
        fee
        feeTitle
        display
        __typename
      }
      hourlyPm {
        rate
        billableHours
        minBillableHours
        feeTitle
        display
        __typename
      }
      percentPm {
        percent
        minFee
        feeTitle
        display
        __typename
      }
      preTipPm {
        chosenPercent
        percentages
        defaultPercentagesIndex
        footer
        feeTitle
        display
        fixedGratuityOptions
        defaultFixedGratuityOptionsIndex
        chosenFixedGratuity
        gratuityType
        showPreGratuityByDefault
        allowOptionalGratuity
        showCustomGratuity
        __typename
      }
      clientPlatformPm {
        percent
        feeTitle
        display
        __typename
      }
      suggestedFlatPm {
        fee
        feeWarningThreshold
        percentages
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedPercentPm {
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      suggestedFlatPlusPercentPm {
        fee
        feeWarningThreshold
        percent
        minFee
        percentWarningThreshold
        minFeeWarningThreshold
        gratuityType
        gratuityOptions
        defaultGratuityOptionsIndex
        clientPaysPlatform
        showCustomGratuity
        title
        description
        __typename
      }
      __typename
    }
    tip
    feeAndPreGratuityDisplay
    deliveryFee
    transactions
    couponCode
    adjustmentDescription
    adjustmentAmount
    adjustments {
      id
      description
      amount
      __typename
    }
    lineItems {
      deliveryFee
      tipPercentage
      tipAmount
      platformPercentage
      platformAmount
      subtotal
      coupon
      total
      earnings
      stores {
        storeName
        storeAmount
        __typename
      }
      couponCode
      additionalTipAmount
      adjustmentDescription
      adjustmentAmount
      __typename
    }
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    review {
      id
      quote
      rating
      timestamp
      __typename
    }
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    additionalTipAmount
    additionalTipDismissed
    pricingData {
      preTip
      loan
      __typename
    }
    externalTransactions {
      id
      description
      amount
      image
      attachment
      moreAttachments
      __typename
    }
    assignedTo
    lockoutHours
    parentOrder {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    childOrders {
      deliveryTimestamp
      orderTimestamp
      orderId
      clientId
      shopperId
      __typename
    }
    credits {
      id
      description
      amount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedOrderQueryVariables,
  APITypes.LinkedOrderQuery
>;
export const linkedOrderPaymentsBreakdown = /* GraphQL */ `query LinkedOrderPaymentsBreakdown($id: ID!, $deliveryTimestamp: String!) {
  linkedOrderPaymentsBreakdown(id: $id, deliveryTimestamp: $deliveryTimestamp) {
    title
    lineItems {
      key
      value
      type
      metadata {
        txId
        adjustmentDescription
        paymentUTCTimestamp
        image
        __typename
      }
      __typename
    }
    final {
      key
      value
      type
      metadata {
        txId
        adjustmentDescription
        paymentUTCTimestamp
        image
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkedOrderPaymentsBreakdownQueryVariables,
  APITypes.LinkedOrderPaymentsBreakdownQuery
>;
export const unusedTransactions = /* GraphQL */ `query UnusedTransactions($count: Int, $nextToken: String) {
  unusedTransactions(count: $count, nextToken: $nextToken) {
    transactions {
      id
      update_time
      merchantName
      merchantCity
      merchantState
      merchantZip
      merchantCountry
      merchantLocalTime
      transactionUtcTime
      transactionAmount
      image
      last4
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UnusedTransactionsQueryVariables,
  APITypes.UnusedTransactionsQuery
>;
export const orderTransactions = /* GraphQL */ `query OrderTransactions($id: ID!, $deliveryTimestamp: String!) {
  orderTransactions(id: $id, deliveryTimestamp: $deliveryTimestamp) {
    id
    update_time
    merchantName
    merchantCity
    merchantState
    merchantZip
    merchantCountry
    merchantLocalTime
    transactionUtcTime
    transactionAmount
    image
    moreImages
    last4
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderTransactionsQueryVariables,
  APITypes.OrderTransactionsQuery
>;
export const orderLineItems = /* GraphQL */ `query OrderLineItems($id: ID!, $deliveryTimestamp: String!) {
  orderLineItems(id: $id, deliveryTimestamp: $deliveryTimestamp) {
    deliveryFee
    tipPercentage
    tipAmount
    platformPercentage
    platformAmount
    subtotal
    coupon
    total
    earnings
    stores {
      storeName
      storeAmount
      __typename
    }
    couponCode
    additionalTipAmount
    adjustmentDescription
    adjustmentAmount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderLineItemsQueryVariables,
  APITypes.OrderLineItemsQuery
>;
export const presignedPostUrl = /* GraphQL */ `query PresignedPostUrl($fileName: String!, $contentType: String!) {
  presignedPostUrl(fileName: $fileName, contentType: $contentType) {
    presignedPostUrl
    presignedPostUrlFields
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PresignedPostUrlQueryVariables,
  APITypes.PresignedPostUrlQuery
>;
export const transactionPresignedPostUrl = /* GraphQL */ `query TransactionPresignedPostUrl($contentType: String!) {
  transactionPresignedPostUrl(contentType: $contentType) {
    fileName
    presignedPostUrl
    presignedPostUrlFields
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TransactionPresignedPostUrlQueryVariables,
  APITypes.TransactionPresignedPostUrlQuery
>;
export const profile = /* GraphQL */ `query Profile($id: ID!) {
  profile(id: $id) {
    userId
    phone
    __typename
  }
}
` as GeneratedQuery<APITypes.ProfileQueryVariables, APITypes.ProfileQuery>;
export const getSharedListByServiceName = /* GraphQL */ `query GetSharedListByServiceName($serviceName: String) {
  getSharedListByServiceName(serviceName: $serviceName) {
    id
    owner
    listId
    listName
    storeName
    items {
      owner
      listId
      itemId
      catalogId
      position
      name
      image
      unit
      count
      note
      checkedOff
      checkedOffTimestamp
      shopperPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      description
      price
      pricePerUnit
      weight
      weightUnit
      displaySize
      link
      selectedProductOptions {
        name
        selection
        __typename
      }
      __typename
    }
    sharedWith
    clientId
    orderId
    orderTimestamp
    serviceImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSharedListByServiceNameQueryVariables,
  APITypes.GetSharedListByServiceNameQuery
>;
export const sharedList = /* GraphQL */ `query SharedList($owner: ID!, $listId: ID!, $snapshotId: ID) {
  sharedList(owner: $owner, listId: $listId, snapshotId: $snapshotId) {
    id
    owner
    listId
    listName
    storeName
    items {
      owner
      listId
      itemId
      catalogId
      position
      name
      image
      unit
      count
      note
      checkedOff
      checkedOffTimestamp
      shopperPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      description
      price
      pricePerUnit
      weight
      weightUnit
      displaySize
      link
      selectedProductOptions {
        name
        selection
        __typename
      }
      __typename
    }
    sharedWith
    clientId
    orderId
    orderTimestamp
    serviceImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SharedListQueryVariables,
  APITypes.SharedListQuery
>;
export const getSharedListByServiceNameOrIds = /* GraphQL */ `query GetSharedListByServiceNameOrIds(
  $serviceName: String
  $owner: ID
  $listId: ID
  $snapshotId: ID
) {
  getSharedListByServiceNameOrIds(
    serviceName: $serviceName
    owner: $owner
    listId: $listId
    snapshotId: $snapshotId
  ) {
    id
    owner
    listId
    listName
    storeName
    items {
      owner
      listId
      itemId
      catalogId
      position
      name
      image
      unit
      count
      note
      checkedOff
      checkedOffTimestamp
      shopperPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      description
      price
      pricePerUnit
      weight
      weightUnit
      displaySize
      link
      selectedProductOptions {
        name
        selection
        __typename
      }
      __typename
    }
    sharedWith
    clientId
    orderId
    orderTimestamp
    serviceImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSharedListByServiceNameOrIdsQueryVariables,
  APITypes.GetSharedListByServiceNameOrIdsQuery
>;
export const allSharedListIdentifiers = /* GraphQL */ `query AllSharedListIdentifiers($count: Int, $nextToken: String) {
  allSharedListIdentifiers(count: $count, nextToken: $nextToken) {
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllSharedListIdentifiersQueryVariables,
  APITypes.AllSharedListIdentifiersQuery
>;
export const sharedListIdentifiersForServiceName = /* GraphQL */ `query SharedListIdentifiersForServiceName(
  $serviceName: String
  $count: Int
  $nextToken: String
) {
  sharedListIdentifiersForServiceName(
    serviceName: $serviceName
    count: $count
    nextToken: $nextToken
  ) {
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SharedListIdentifiersForServiceNameQueryVariables,
  APITypes.SharedListIdentifiersForServiceNameQuery
>;
export const clientServiceNameSharedLists = /* GraphQL */ `query ClientServiceNameSharedLists($count: Int, $nextToken: String) {
  clientServiceNameSharedLists(count: $count, nextToken: $nextToken) {
    sharedListIdentifiers {
      owner
      listId
      snapshotId
      listName
      storeName
      hasOpenOrder
      clientId
      orderId
      orderTimestamp
      serviceImage
      itemCount
      numItems
      numUnits
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientServiceNameSharedListsQueryVariables,
  APITypes.ClientServiceNameSharedListsQuery
>;
export const customSuggest = /* GraphQL */ `query CustomSuggest($store: String!, $text: String!, $timestamp: String!) {
  customSuggest(store: $store, text: $text, timestamp: $timestamp) {
    text
    timestamp
    results {
      image
      text
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomSuggestQueryVariables,
  APITypes.CustomSuggestQuery
>;
export const customSearch = /* GraphQL */ `query CustomSearch($store: String!, $text: String!, $timestamp: String!) {
  customSearch(store: $store, text: $text, timestamp: $timestamp) {
    text
    timestamp
    results {
      image
      text
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomSearchQueryVariables,
  APITypes.CustomSearchQuery
>;
export const productDetails = /* GraphQL */ `query ProductDetails($productId: ID!, $listId: ID) {
  productDetails(productId: $productId, listId: $listId) {
    id
    product {
      id
      name
      description
      categories
      price {
        cents
        text
        __typename
      }
      salePrice {
        cents
        text
        __typename
      }
      displaySize
      media {
        ... on MediaImage {
          small {
            width
            height
            path
            mimeType
            __typename
          }
          medium {
            width
            height
            path
            mimeType
            __typename
          }
          large {
            width
            height
            path
            mimeType
            __typename
          }
          xlarge {
            width
            height
            path
            mimeType
            __typename
          }
          full {
            width
            height
            path
            mimeType
            __typename
          }
        }
      }
      link
      isCustom
      __typename
    }
    note
    quantity
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductDetailsQueryVariables,
  APITypes.ProductDetailsQuery
>;
export const getStreamToken = /* GraphQL */ `query GetStreamToken($id: ID!) {
  getStreamToken(id: $id) {
    token
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStreamTokenQueryVariables,
  APITypes.GetStreamTokenQuery
>;
export const productV3Search = /* GraphQL */ `query ProductV3Search(
  $store: String!
  $breadcrumbs: [String]!
  $text: String!
  $sortType: SearchResultsSortOptionType
  $count: Int
  $listId: ID
  $maxDepth: Int
) {
  productV3Search(
    store: $store
    breadcrumbs: $breadcrumbs
    text: $text
    sortType: $sortType
    count: $count
    listId: $listId
    maxDepth: $maxDepth
  ) {
    store
    category
    text
    results {
      id
      dumplingId
      sellerName
      name
      sellerId
      available
      allowed
      description
      upc
      categories
      price
      salePrice
      clubPrice
      pricePerUnit
      salePricePerUnit
      unitType
      weightUnit
      weight
      displaySize
      imageLink
      image
      link
      note
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      __typename
    }
    categories
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductV3SearchQueryVariables,
  APITypes.ProductV3SearchQuery
>;
export const productV3StoreCategories = /* GraphQL */ `query ProductV3StoreCategories($store: String!, $breadcrumbs: [String]) {
  productV3StoreCategories(store: $store, breadcrumbs: $breadcrumbs) {
    store
    categories
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductV3StoreCategoriesQueryVariables,
  APITypes.ProductV3StoreCategoriesQuery
>;
export const productV3StoreCategories2 = /* GraphQL */ `query ProductV3StoreCategories2($store: String!, $breadcrumbs: [String]) {
  productV3StoreCategories2(store: $store, breadcrumbs: $breadcrumbs) {
    store
    categories
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductV3StoreCategories2QueryVariables,
  APITypes.ProductV3StoreCategories2Query
>;
export const productV3Suggest = /* GraphQL */ `query ProductV3Suggest($store: String!, $text: String!, $timestamp: String!) {
  productV3Suggest(store: $store, text: $text, timestamp: $timestamp) {
    text
    timestamp
    results {
      image
      text
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductV3SuggestQueryVariables,
  APITypes.ProductV3SuggestQuery
>;
export const genericProductSearch = /* GraphQL */ `query GenericProductSearch(
  $store: String!
  $text: String!
  $breadcrumbs: [String]
  $count: Int
  $listId: ID
  $maxDepth: Int
  $limitGroupTypes: [GenericProductResultsGroupType]
) {
  genericProductSearch(
    store: $store
    text: $text
    breadcrumbs: $breadcrumbs
    count: $count
    listId: $listId
    maxDepth: $maxDepth
    limitGroupTypes: $limitGroupTypes
  ) {
    store
    title
    subTitle
    description
    externalUrl
    internalUrl
    type
    results {
      id
      dumplingId
      sellerName
      name
      sellerId
      available
      allowed
      description
      upc
      categories
      price
      salePrice
      clubPrice
      pricePerUnit
      salePricePerUnit
      unitType
      weightUnit
      weight
      displaySize
      imageLink
      image
      link
      note
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GenericProductSearchQueryVariables,
  APITypes.GenericProductSearchQuery
>;
export const pastItems = /* GraphQL */ `query PastItems($store: String!) {
  pastItems(store: $store) {
    store
    category
    text
    results {
      id
      dumplingId
      sellerName
      name
      sellerId
      available
      allowed
      description
      upc
      categories
      price
      salePrice
      clubPrice
      pricePerUnit
      salePricePerUnit
      unitType
      weightUnit
      weight
      displaySize
      imageLink
      image
      link
      note
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      __typename
    }
    categories
    __typename
  }
}
` as GeneratedQuery<APITypes.PastItemsQueryVariables, APITypes.PastItemsQuery>;
export const clientReviews = /* GraphQL */ `query ClientReviews($sortOrder: String, $count: Int, $nextToken: String) {
  clientReviews(sortOrder: $sortOrder, count: $count, nextToken: $nextToken) {
    clientReviews {
      id
      quote
      date
      rating
      clientName
      clientImage
      pinned
      hidden
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientReviewsQueryVariables,
  APITypes.ClientReviewsQuery
>;
export const shopperReviews = /* GraphQL */ `query ShopperReviews($shopperId: ID!, $count: Int, $nextToken: String) {
  shopperReviews(shopperId: $shopperId, count: $count, nextToken: $nextToken) {
    clientReviews {
      id
      quote
      date
      rating
      clientName
      clientImage
      pinned
      hidden
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperReviewsQueryVariables,
  APITypes.ShopperReviewsQuery
>;
export const shopperGeoSearch = /* GraphQL */ `query ShopperGeoSearch($zipcode: String, $count: Int, $nextToken: String) {
  shopperGeoSearch(zipcode: $zipcode, count: $count, nextToken: $nextToken) {
    announcement
    shoppers {
      id
      firstName
      lastName
      displayName
      deliveryArea
      websiteUrl
      phone
      businessPhone
      email
      bio
      image
      businessName
      availabilityDescription
      announcement
      rating
      repeatClientCount
      orderCount
      reviewCount
      specialtyTags
      tagline
      metaTitle
      metaImage
      metaDescription
      deliveryAreaZipcode
      deliveryAreaZipcodes
      deliveryRadius
      lowestPrice
      subscriptionPlan
      subscriptionPlanDetails {
        id
        textComponents {
          text
          bold
          __typename
        }
        phases {
          id
          status
          __typename
        }
        __typename
      }
      branding {
        coverColor
        __typename
      }
      typicalPricing {
        summary {
          title
          description
          __typename
        }
        groceries
        shoppingAndDelivery
        minGratuity
        platform
        __typename
      }
      allowClientConnection
      stripeConnectAcctExists
      fullSSNRequired
      attnBizProfile
      attnDirectDeposit
      attnCreditCard
      attnServices
      attnPassword
      statusIdentityVerification {
        state
        message
        externalLink
        __typename
      }
      statusChargeCard {
        state
        message
        externalLink
        __typename
      }
      optInEngage
      optInZipcode
      deactivated
      acceptsReferralNetwork
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperGeoSearchQueryVariables,
  APITypes.ShopperGeoSearchQuery
>;
export const shopperDetails = /* GraphQL */ `query ShopperDetails($shopperId: ID!) {
  shopperDetails(shopperId: $shopperId) {
    id
    shopper {
      id
      firstName
      lastName
      displayName
      deliveryArea
      websiteUrl
      phone
      businessPhone
      email
      bio
      image
      businessName
      availabilityDescription
      announcement
      rating
      repeatClientCount
      orderCount
      reviewCount
      specialtyTags
      tagline
      metaTitle
      metaImage
      metaDescription
      deliveryAreaZipcode
      deliveryAreaZipcodes
      deliveryRadius
      lowestPrice
      subscriptionPlan
      subscriptionPlanDetails {
        id
        textComponents {
          text
          bold
          __typename
        }
        phases {
          id
          status
          __typename
        }
        __typename
      }
      branding {
        coverColor
        __typename
      }
      typicalPricing {
        summary {
          title
          description
          __typename
        }
        groceries
        shoppingAndDelivery
        minGratuity
        platform
        __typename
      }
      allowClientConnection
      stripeConnectAcctExists
      fullSSNRequired
      attnBizProfile
      attnDirectDeposit
      attnCreditCard
      attnServices
      attnPassword
      statusIdentityVerification {
        state
        message
        externalLink
        __typename
      }
      statusChargeCard {
        state
        message
        externalLink
        __typename
      }
      optInEngage
      optInZipcode
      deactivated
      acceptsReferralNetwork
      __typename
    }
    serviceOfferings {
      id
      serviceName
      serviceImage
      serviceDescription
      defaultErrandBusinessNames
      baseFee
      maxErrands
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      disclaimerText
      useSuggestedPricing
      __typename
    }
    shopperSchedule {
      id
      dailySchedules {
        id
        day
        timeSlots {
          id
          slotStart
          slotEnd
          isActive
          bufferDuration
          bufferMode
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperDetailsQueryVariables,
  APITypes.ShopperDetailsQuery
>;
export const estimatedCartTotal = /* GraphQL */ `query EstimatedCartTotal($owner: ID!, $listId: ID!, $snapshotId: ID) {
  estimatedCartTotal(owner: $owner, listId: $listId, snapshotId: $snapshotId) {
    owner
    listId
    snapshotId
    cartTotalLines {
      count
      label
      value
      __typename
    }
    cartTotal {
      count
      label
      value
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimatedCartTotalQueryVariables,
  APITypes.EstimatedCartTotalQuery
>;
export const estimatedOrderTotal = /* GraphQL */ `query EstimatedOrderTotal(
  $deliveryFee: Int!
  $tip: Int
  $couponCode: String
  $owner: ID!
  $listId: ID!
  $snapshotId: ID
) {
  estimatedOrderTotal(
    deliveryFee: $deliveryFee
    tip: $tip
    couponCode: $couponCode
    owner: $owner
    listId: $listId
    snapshotId: $snapshotId
  ) {
    deliveryFee
    tip
    couponCode
    owner
    listId
    snapshotId
    orderTotalLines {
      label
      value
      icon
      __typename
    }
    orderCoupon {
      label
      value
      icon
      __typename
    }
    orderTotal {
      label
      value
      icon
      __typename
    }
    authValue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimatedOrderTotalQueryVariables,
  APITypes.EstimatedOrderTotalQuery
>;
export const estimatedOrderTotalPreview = /* GraphQL */ `query EstimatedOrderTotalPreview($input: OrderPreviewInput) {
  estimatedOrderTotalPreview(input: $input) {
    deliveryFee
    tip
    couponCode
    owner
    listId
    snapshotId
    orderTotalLines {
      label
      value
      icon
      __typename
    }
    orderCoupon {
      label
      value
      icon
      __typename
    }
    orderTotal {
      label
      value
      icon
      __typename
    }
    authValue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimatedOrderTotalPreviewQueryVariables,
  APITypes.EstimatedOrderTotalPreviewQuery
>;
export const estimatedOrderTotalClient = /* GraphQL */ `query EstimatedOrderTotalClient($orderId: ID, $orderTimestamp: String) {
  estimatedOrderTotalClient(
    orderId: $orderId
    orderTimestamp: $orderTimestamp
  ) {
    deliveryFee
    tip
    couponCode
    owner
    listId
    snapshotId
    orderTotalLines {
      label
      value
      icon
      __typename
    }
    orderCoupon {
      label
      value
      icon
      __typename
    }
    orderTotal {
      label
      value
      icon
      __typename
    }
    authValue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimatedOrderTotalClientQueryVariables,
  APITypes.EstimatedOrderTotalClientQuery
>;
export const postTip = /* GraphQL */ `query PostTip($orderId: ID, $orderTimestamp: String) {
  postTip(orderId: $orderId, orderTimestamp: $orderTimestamp) {
    baseDisplayAmount
    __typename
  }
}
` as GeneratedQuery<APITypes.PostTipQueryVariables, APITypes.PostTipQuery>;
export const estimatedOrderTotalShopper = /* GraphQL */ `query EstimatedOrderTotalShopper($orderId: ID, $deliveryTimestamp: String) {
  estimatedOrderTotalShopper(
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
  ) {
    deliveryFee
    tip
    couponCode
    owner
    listId
    snapshotId
    orderTotalLines {
      label
      value
      icon
      __typename
    }
    orderCoupon {
      label
      value
      icon
      __typename
    }
    orderTotal {
      label
      value
      icon
      __typename
    }
    authValue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimatedOrderTotalShopperQueryVariables,
  APITypes.EstimatedOrderTotalShopperQuery
>;
export const postTipReferences = /* GraphQL */ `query PostTipReferences($clientId: ID!) {
  postTipReferences(clientId: $clientId) {
    orderId
    clientId
    orderTimestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostTipReferencesQueryVariables,
  APITypes.PostTipReferencesQuery
>;
export const postTipInfo = /* GraphQL */ `query PostTipInfo($clientId: ID!, $orderId: ID!, $orderTimestamp: String!) {
  postTipInfo(
    clientId: $clientId
    orderId: $orderId
    orderTimestamp: $orderTimestamp
  ) {
    orderId
    clientId
    orderTimestamp
    orderTotal
    preTipAmount
    shopperDisplayName
    shopperImage
    serviceName
    serviceImage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PostTipInfoQueryVariables,
  APITypes.PostTipInfoQuery
>;
export const orderPostGratuityAndReviewInfos = /* GraphQL */ `query OrderPostGratuityAndReviewInfos($clientId: ID!) {
  orderPostGratuityAndReviewInfos(clientId: $clientId) {
    showPostGratuity
    showReview
    order {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      listReferences {
        storeName
        storeImage
        storeId
        id
        listName
        listItemCount
        listVersion
        lastCompletedOrderId
        savedListId
        savedListItemCount
        savedListVersion
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    baseAmount
    defaultPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    gratuityType
    gratuityOptions
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderPostGratuityAndReviewInfosQueryVariables,
  APITypes.OrderPostGratuityAndReviewInfosQuery
>;
export const orderPostGratuityInfo = /* GraphQL */ `query OrderPostGratuityInfo(
  $clientId: ID!
  $orderId: ID!
  $orderTimestamp: String!
) {
  orderPostGratuityInfo(
    clientId: $clientId
    orderId: $orderId
    orderTimestamp: $orderTimestamp
  ) {
    order {
      version
      id
      clientId
      shopperId
      shopperInfo {
        image
        displayName
        email
        __typename
      }
      firstName
      lastName
      phone
      email
      clientImage
      note
      privateNote
      adminNote
      conciergeNote
      orderStatus
      orderDateTime
      orderTimestamp
      deliveryDate
      deliveryTime
      deliveryTimestamp
      deliveryStartDateTime
      deliveryEndDateTime
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      orderPaymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      serviceRequestList {
        serviceId
        serviceName
        image
        errandList {
          businessName
          shoppingItemCount
          shoppingList {
            id
            itemName
            itemNote
            isDone
            __typename
          }
          __typename
        }
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      tip
      feeAndPreGratuityDisplay
      deliveryFee
      transactions
      couponCode
      adjustmentDescription
      adjustmentAmount
      adjustments {
        id
        description
        amount
        __typename
      }
      lineItems {
        deliveryFee
        tipPercentage
        tipAmount
        platformPercentage
        platformAmount
        subtotal
        coupon
        total
        earnings
        stores {
          storeName
          storeAmount
          __typename
        }
        couponCode
        additionalTipAmount
        adjustmentDescription
        adjustmentAmount
        __typename
      }
      priceBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      earningsBreakdown {
        title
        lineItems {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        final {
          key
          value
          type
          metadata {
            txId
            adjustmentDescription
            paymentUTCTimestamp
            image
            __typename
          }
          __typename
        }
        __typename
      }
      review {
        id
        quote
        rating
        timestamp
        __typename
      }
      sharedListIdentifiers {
        owner
        listId
        snapshotId
        listName
        storeName
        hasOpenOrder
        clientId
        orderId
        orderTimestamp
        serviceImage
        itemCount
        numItems
        numUnits
        __typename
      }
      listReferences {
        storeName
        storeImage
        storeId
        id
        listName
        listItemCount
        listVersion
        lastCompletedOrderId
        savedListId
        savedListItemCount
        savedListVersion
        __typename
      }
      additionalTipAmount
      additionalTipDismissed
      pricingData {
        preTip
        loan
        __typename
      }
      externalTransactions {
        id
        description
        amount
        image
        attachment
        __typename
      }
      assignedTo
      lockoutHours
      parentOrder {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      childOrders {
        deliveryTimestamp
        orderTimestamp
        orderId
        clientId
        shopperId
        __typename
      }
      credits {
        id
        description
        amount
        __typename
      }
      __typename
    }
    baseAmount
    defaultPaymentMethod {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    gratuityType
    gratuityOptions
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderPostGratuityInfoQueryVariables,
  APITypes.OrderPostGratuityInfoQuery
>;
export const bossPlans = /* GraphQL */ `query BossPlans {
  bossPlans {
    id
    title
    description
    cost
    interval
    mostPopular
    __typename
  }
}
` as GeneratedQuery<APITypes.BossPlansQueryVariables, APITypes.BossPlansQuery>;
export const bossPlanPreview = /* GraphQL */ `query BossPlanPreview($id: ID) {
  bossPlanPreview(id: $id) {
    title
    description
    breakdown {
      key
      value
      type
      metadata {
        txId
        adjustmentDescription
        paymentUTCTimestamp
        image
        __typename
      }
      __typename
    }
    cta
    paymentRequired
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossPlanPreviewQueryVariables,
  APITypes.BossPlanPreviewQuery
>;
export const bossPaymentMethods = /* GraphQL */ `query BossPaymentMethods($count: Int, $nextToken: String) {
  bossPaymentMethods(count: $count, nextToken: $nextToken) {
    paymentMethods {
      id
      brand
      expirationMonth
      expirationYear
      last4
      isDefault
      address {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossPaymentMethodsQueryVariables,
  APITypes.BossPaymentMethodsQuery
>;
export const bossPayouts = /* GraphQL */ `query BossPayouts($count: Int, $nextToken: String) {
  bossPayouts(count: $count, nextToken: $nextToken) {
    futurePayoutAmount
    payouts {
      id
      amount
      status
      arrivalTimestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossPayoutsQueryVariables,
  APITypes.BossPayoutsQuery
>;
export const bossPayoutDetails = /* GraphQL */ `query BossPayoutDetails($payoutId: ID!) {
  bossPayoutDetails(payoutId: $payoutId) {
    id
    header {
      key
      value
      type
      metadata {
        txId
        adjustmentDescription
        paymentUTCTimestamp
        image
        __typename
      }
      __typename
    }
    payments {
      id
      amount
      client
      date
      orderId
      deliveryTimestamp
      postTip
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossPayoutDetailsQueryVariables,
  APITypes.BossPayoutDetailsQuery
>;
export const bossInsightsBasic = /* GraphQL */ `query BossInsightsBasic {
  bossInsightsBasic {
    profileImage
    ratings {
      score
      reviewCount
      reviewCountBreakdown
      __typename
    }
    trends {
      charts {
        tab
        maxBarHeight
        bars {
          xLabel
          barLabel
          barHeight
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossInsightsBasicQueryVariables,
  APITypes.BossInsightsBasicQuery
>;
export const bossInsightsMetrics = /* GraphQL */ `query BossInsightsMetrics($period: String!) {
  bossInsightsMetrics(period: $period) {
    tab
    dateRange
    earnings
    orderCount
    clientCount
    repeatClientCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossInsightsMetricsQueryVariables,
  APITypes.BossInsightsMetricsQuery
>;
export const bossAvailableSchedule = /* GraphQL */ `query BossAvailableSchedule($id: ID, $input: ShopperAvailableScheduleInput!) {
  bossAvailableSchedule(id: $id, input: $input) {
    firstAvailableDayIndex
    firstAvailableTimeSlotOfDayIndex
    dailyAvailableSchedules {
      day
      date
      isClosed
      availableTimeSlots {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossAvailableScheduleQueryVariables,
  APITypes.BossAvailableScheduleQuery
>;
export const bossStripeAccountVerifyLink = /* GraphQL */ `query BossStripeAccountVerifyLink($id: ID) {
  bossStripeAccountVerifyLink(id: $id) {
    url
    expiresAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossStripeAccountVerifyLinkQueryVariables,
  APITypes.BossStripeAccountVerifyLinkQuery
>;
export const getAutoMessages = /* GraphQL */ `query GetAutoMessages($count: Int, $nextToken: String) {
  getAutoMessages(count: $count, nextToken: $nextToken) {
    autoMessages {
      id
      type
      title
      action
      message
      defaultMessage
      description
      enabled
      delaySeconds
      defaultDelaySeconds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutoMessagesQueryVariables,
  APITypes.GetAutoMessagesQuery
>;
export const clientAvailableUpdate = /* GraphQL */ `query ClientAvailableUpdate {
  clientAvailableUpdate {
    isRequired
    availableVersion
    note
    infoUrl
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientAvailableUpdateQueryVariables,
  APITypes.ClientAvailableUpdateQuery
>;
export const getListReferences = /* GraphQL */ `query GetListReferences($count: Int!, $nextToken: String!) {
  getListReferences(count: $count, nextToken: $nextToken) {
    nextToken
    listReferences {
      storeName
      storeImage
      storeId
      id
      listName
      listItemCount
      listVersion
      lastCompletedOrderId
      savedListId
      savedListItemCount
      savedListVersion
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListReferencesQueryVariables,
  APITypes.GetListReferencesQuery
>;
export const getListDetails = /* GraphQL */ `query GetListDetails($listId: ID!) {
  getListDetails(listId: $listId) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListDetailsQueryVariables,
  APITypes.GetListDetailsQuery
>;
export const getCardFundingOrder = /* GraphQL */ `query GetCardFundingOrder($deliveryTimestamp: String!, $orderId: ID!) {
  getCardFundingOrder(
    deliveryTimestamp: $deliveryTimestamp
    orderId: $orderId
  ) {
    userId
    orderId
    deliveryTimestamp
    fundingCents
    fundingDisplayCents
    fundingDisplayDollars
    fundingStatus
    fundingWarning
    contactMessage
    displayFunding
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCardFundingOrderQueryVariables,
  APITypes.GetCardFundingOrderQuery
>;
export const getAvailableStores = /* GraphQL */ `query GetAvailableStores($shopperId: ID, $request: String) {
  getAvailableStores(shopperId: $shopperId, request: $request) {
    displayShopperFee
    displayRequestFee
    displayRequestBanner
    disclaimer
    storesSections {
      title
      description
      storeReferences {
        storeImage
        storeName
        id
        storeReferencePricing {
          type
          price
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAvailableStoresQueryVariables,
  APITypes.GetAvailableStoresQuery
>;
export const getStore = /* GraphQL */ `query GetStore($storeId: ID!) {
  getStore(storeId: $storeId) {
    name
    image
    id
    disclaimer
    isCustom
    __typename
  }
}
` as GeneratedQuery<APITypes.GetStoreQueryVariables, APITypes.GetStoreQuery>;
export const getSearchTerms = /* GraphQL */ `query GetSearchTerms(
  $searchText: String!
  $storeId: ID!
  $breadcrumbs: [String!]
) {
  getSearchTerms(
    searchText: $searchText
    storeId: $storeId
    breadcrumbs: $breadcrumbs
  ) {
    ... on SearchTermAutocompleteResult {
      completedTerm
    }
    ... on SearchTermAutosuggestResult {
      suggestedTerm
    }
    ... on SearchTermProductResult {
      name
      itemId
    }
    ... on SearchTermInCategoryResult {
      name
      breadcrumbs
    }
  }
}
` as GeneratedQuery<
  APITypes.GetSearchTermsQueryVariables,
  APITypes.GetSearchTermsQuery
>;
export const getDefaultSearchTerms = /* GraphQL */ `query GetDefaultSearchTerms($storeId: ID!) {
  getDefaultSearchTerms(storeId: $storeId) {
    ... on SearchTermAutocompleteResult {
      completedTerm
    }
    ... on SearchTermAutosuggestResult {
      suggestedTerm
    }
    ... on SearchTermProductResult {
      name
      itemId
    }
    ... on SearchTermInCategoryResult {
      name
      breadcrumbs
    }
  }
}
` as GeneratedQuery<
  APITypes.GetDefaultSearchTermsQueryVariables,
  APITypes.GetDefaultSearchTermsQuery
>;
export const getPricingModel = /* GraphQL */ `query GetPricingModel($shopperId: ID!, $storeId: ID!) {
  getPricingModel(shopperId: $shopperId, storeId: $storeId) {
    version
    description
    flatPm {
      fee
      feeTitle
      display
      __typename
    }
    hourlyPm {
      rate
      billableHours
      minBillableHours
      feeTitle
      display
      __typename
    }
    percentPm {
      percent
      minFee
      feeTitle
      display
      __typename
    }
    preTipPm {
      chosenPercent
      percentages
      defaultPercentagesIndex
      footer
      feeTitle
      display
      fixedGratuityOptions
      defaultFixedGratuityOptionsIndex
      chosenFixedGratuity
      gratuityType
      showPreGratuityByDefault
      allowOptionalGratuity
      showCustomGratuity
      __typename
    }
    clientPlatformPm {
      percent
      feeTitle
      display
      __typename
    }
    suggestedFlatPm {
      fee
      feeWarningThreshold
      percentages
      gratuityType
      gratuityOptions
      defaultGratuityOptionsIndex
      clientPaysPlatform
      showCustomGratuity
      title
      description
      __typename
    }
    suggestedPercentPm {
      percent
      minFee
      percentWarningThreshold
      minFeeWarningThreshold
      gratuityType
      gratuityOptions
      defaultGratuityOptionsIndex
      clientPaysPlatform
      showCustomGratuity
      title
      description
      __typename
    }
    suggestedFlatPlusPercentPm {
      fee
      feeWarningThreshold
      percent
      minFee
      percentWarningThreshold
      minFeeWarningThreshold
      gratuityType
      gratuityOptions
      defaultGratuityOptionsIndex
      clientPaysPlatform
      showCustomGratuity
      title
      description
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPricingModelQueryVariables,
  APITypes.GetPricingModelQuery
>;
export const getShopperSupportedStores = /* GraphQL */ `query GetShopperSupportedStores($shopperId: ID!, $listIds: [ID!]!) {
  getShopperSupportedStores(shopperId: $shopperId, listIds: $listIds) {
    supportedStores {
      storeImage
      storeName
      id
      storeReferencePricing {
        type
        price
        __typename
      }
      __typename
    }
    unsupportedStores {
      storeImage
      storeName
      id
      storeReferencePricing {
        type
        price
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetShopperSupportedStoresQueryVariables,
  APITypes.GetShopperSupportedStoresQuery
>;
export const shopperAvailability = /* GraphQL */ `query ShopperAvailability(
  $shopperId: ID!
  $shopperAvailableScheduleInput: ShopperAvailableScheduleInput!
) {
  shopperAvailability(
    shopperId: $shopperId
    shopperAvailableScheduleInput: $shopperAvailableScheduleInput
  ) {
    id
    shopperAvailabilityDays {
      dayOfWeekType
      shopperAvailabilityType
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperAvailabilityQueryVariables,
  APITypes.ShopperAvailabilityQuery
>;
export const getListNotice = /* GraphQL */ `query GetListNotice($listId: ID!) {
  getListNotice(listId: $listId) {
    id
    type
    title
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListNoticeQueryVariables,
  APITypes.GetListNoticeQuery
>;
export const shopperAvailabilityDescription = /* GraphQL */ `query ShopperAvailabilityDescription(
  $shopperId: ID!
  $shopperAvailableScheduleInput: ShopperAvailableScheduleInput!
) {
  shopperAvailabilityDescription(
    shopperId: $shopperId
    shopperAvailableScheduleInput: $shopperAvailableScheduleInput
  ) {
    id
    description
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperAvailabilityDescriptionQueryVariables,
  APITypes.ShopperAvailabilityDescriptionQuery
>;
export const shopperGetListDetails = /* GraphQL */ `query ShopperGetListDetails($listId: ID!, $owner: ID, $snapshotId: ID) {
  shopperGetListDetails(
    listId: $listId
    owner: $owner
    snapshotId: $snapshotId
  ) {
    id
    savedListId
    listName
    listVersion
    storeName
    storeId
    items {
      id
      catalogId
      media {
        ... on ProductImage {
          imageUrl
        }
        ... on ProductVideo {
          videoUrl
        }
      }
      attributedMedia {
        media {
          ... on MediaImage {
            small {
              width
              height
              path
              mimeType
              __typename
            }
            medium {
              width
              height
              path
              mimeType
              __typename
            }
            large {
              width
              height
              path
              mimeType
              __typename
            }
            xlarge {
              width
              height
              path
              mimeType
              __typename
            }
            full {
              width
              height
              path
              mimeType
              __typename
            }
          }
        }
        sourceUrl
        hostPageUrl
        hostPageName
        __typename
      }
      count
      note
      isCustom
      name
      priceCents
      displayPrice
      salePriceCents
      saleDisplayPrice
      position
      category
      categoryEmoji
      displayUnit
      referenceLink
      deleted
      available
      lastUpdatedTimestamp
      shopperNote
      createdByShopperId
      shopperPosition
      shopperCategoryPosition
      shopperCheckedOff
      shopperCheckedOffTimestamp
      shopperNotAvailable
      selectedProductOptions {
        name
        selection
        __typename
      }
      packageLineItems {
        productId
        name
        quantity
        note
        selectedProductOptions {
          name
          selection
          __typename
        }
        __typename
      }
      __typename
    }
    estimatedTotal {
      id
      displayPrice
      __typename
    }
    estimatedCheckoutTotal {
      id
      displayPrice
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperGetListDetailsQueryVariables,
  APITypes.ShopperGetListDetailsQuery
>;
export const shopperProductDetails = /* GraphQL */ `query ShopperProductDetails(
  $productId: ID!
  $listId: ID
  $owner: ID
  $snapshot: ID
) {
  shopperProductDetails(
    productId: $productId
    listId: $listId
    owner: $owner
    snapshot: $snapshot
  ) {
    id
    product {
      id
      name
      description
      categories
      price {
        cents
        text
        __typename
      }
      salePrice {
        cents
        text
        __typename
      }
      displaySize
      media {
        ... on MediaImage {
          small {
            width
            height
            path
            mimeType
            __typename
          }
          medium {
            width
            height
            path
            mimeType
            __typename
          }
          large {
            width
            height
            path
            mimeType
            __typename
          }
          xlarge {
            width
            height
            path
            mimeType
            __typename
          }
          full {
            width
            height
            path
            mimeType
            __typename
          }
        }
      }
      link
      isCustom
      __typename
    }
    note
    quantity
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperProductDetailsQueryVariables,
  APITypes.ShopperProductDetailsQuery
>;
export const storeSearchOptions = /* GraphQL */ `query StoreSearchOptions($storeId: ID!, $maxDepth: Int!) {
  storeSearchOptions(storeId: $storeId, maxDepth: $maxDepth) {
    id
    categories {
      name
      breadcrumbs
      children {
        name
        breadcrumbs
        children {
          name
          breadcrumbs
          children {
            name
            breadcrumbs
            image
            categoryEmoji
            __typename
          }
          image
          categoryEmoji
          __typename
        }
        image
        categoryEmoji
        __typename
      }
      image
      categoryEmoji
      __typename
    }
    sort {
      name
      type
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoreSearchOptionsQueryVariables,
  APITypes.StoreSearchOptionsQuery
>;
export const storeListActions = /* GraphQL */ `query StoreListActions($storeId: ID!, $listId: ID) {
  storeListActions(storeId: $storeId, listId: $listId) {
    id
    actions {
      ... on SearchStoreListAction {
        name
        buyAgainBreadcrumbs
      }
      ... on BrowseListAction {
        name
        buyAgainBreadcrumbs
      }
      ... on BuyAgainListAction {
        name
        breadcrumbs
      }
      ... on AddItemsListAction {
        name
      }
      ... on PastItemsListAction {
        name
        breadcrumbs
      }
      ... on FilterListAction {
        name
        breadcrumbs
        sortType
      }
      ... on SavedItemsListAction {
        name
        listId
        listItemCount
      }
      ... on BrowseStoreListAction {
        name
      }
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoreListActionsQueryVariables,
  APITypes.StoreListActionsQuery
>;
export const storeHighlightsCarousels = /* GraphQL */ `query StoreHighlightsCarousels($storeId: ID!, $listId: ID!) {
  storeHighlightsCarousels(storeId: $storeId, listId: $listId) {
    id
    carousels {
      id
      name
      products {
        id
        dumplingId
        sellerName
        name
        sellerId
        available
        allowed
        description
        upc
        categories
        price
        salePrice
        clubPrice
        pricePerUnit
        salePricePerUnit
        unitType
        weightUnit
        weight
        displaySize
        imageLink
        image
        link
        note
        attributedMedia {
          sourceUrl
          hostPageUrl
          hostPageName
          __typename
        }
        __typename
      }
      action {
        ... on ProductFilterAction {
          breadcrumbs
          sortType
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoreHighlightsCarouselsQueryVariables,
  APITypes.StoreHighlightsCarouselsQuery
>;
export const storeCanonicalCategories = /* GraphQL */ `query StoreCanonicalCategories($storeId: ID!, $maxDepth: Int!) {
  storeCanonicalCategories(storeId: $storeId, maxDepth: $maxDepth) {
    id
    categories {
      name
      breadcrumbs
      children {
        name
        breadcrumbs
        children {
          name
          breadcrumbs
          children {
            name
            breadcrumbs
            image
            categoryEmoji
            __typename
          }
          image
          categoryEmoji
          __typename
        }
        image
        categoryEmoji
        __typename
      }
      image
      categoryEmoji
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StoreCanonicalCategoriesQueryVariables,
  APITypes.StoreCanonicalCategoriesQuery
>;
export const shopperGetListChanges = /* GraphQL */ `query ShopperGetListChanges($listId: ID!, $owner: ID, $snapshotId: ID) {
  shopperGetListChanges(
    listId: $listId
    owner: $owner
    snapshotId: $snapshotId
  ) {
    id
    fromListVersion
    toListVersion
    changes {
      itemId
      changedBy
      added
      deleted
      diff {
        added {
          key
          value
          dataType
          __typename
        }
        deleted {
          key
          value
          dataType
          __typename
        }
        updated {
          key
          old
          new
          dataType
          __typename
        }
        __typename
      }
      __typename
    }
    list {
      id
      savedListId
      listName
      listVersion
      storeName
      storeId
      items {
        id
        catalogId
        media {
          ... on ProductImage {
            imageUrl
          }
          ... on ProductVideo {
            videoUrl
          }
        }
        attributedMedia {
          sourceUrl
          hostPageUrl
          hostPageName
          __typename
        }
        count
        note
        isCustom
        name
        priceCents
        displayPrice
        salePriceCents
        saleDisplayPrice
        position
        category
        categoryEmoji
        displayUnit
        referenceLink
        deleted
        available
        lastUpdatedTimestamp
        shopperNote
        createdByShopperId
        shopperPosition
        shopperCategoryPosition
        shopperCheckedOff
        shopperCheckedOffTimestamp
        shopperNotAvailable
        selectedProductOptions {
          name
          selection
          __typename
        }
        packageLineItems {
          productId
          name
          quantity
          note
          selectedProductOptions {
            name
            selection
            __typename
          }
          __typename
        }
        __typename
      }
      estimatedTotal {
        id
        displayPrice
        __typename
      }
      estimatedCheckoutTotal {
        id
        displayPrice
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ShopperGetListChangesQueryVariables,
  APITypes.ShopperGetListChangesQuery
>;
export const getInstantPayoutAccounts = /* GraphQL */ `query GetInstantPayoutAccounts {
  getInstantPayoutAccounts {
    id
    brand
    expirationMonth
    expirationYear
    last4
    isDefault
    isVerified
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInstantPayoutAccountsQueryVariables,
  APITypes.GetInstantPayoutAccountsQuery
>;
export const getAvailableInstantPayoutDetails = /* GraphQL */ `query GetAvailableInstantPayoutDetails {
  getAvailableInstantPayoutDetails {
    balance
    fee
    amount
    calculatedTimestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAvailableInstantPayoutDetailsQueryVariables,
  APITypes.GetAvailableInstantPayoutDetailsQuery
>;
export const getFeatureStates = /* GraphQL */ `query GetFeatureStates($id: [ID!]!, $isClientRequest: Boolean) {
  getFeatureStates(id: $id, isClientRequest: $isClientRequest) {
    id
    enabled
    state {
      key
      value
      dataType
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureStatesQueryVariables,
  APITypes.GetFeatureStatesQuery
>;
export const getCart = /* GraphQL */ `query GetCart($id: ID) {
  getCart(id: $id) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCartQueryVariables, APITypes.GetCartQuery>;
export const getMarketplaceInfo = /* GraphQL */ `query GetMarketplaceInfo($zipcode: String!) {
  getMarketplaceInfo(zipcode: $zipcode) {
    zipcode
    marketplaceType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMarketplaceInfoQueryVariables,
  APITypes.GetMarketplaceInfoQuery
>;
export const getActivityList = /* GraphQL */ `query GetActivityList(
  $currentFilterStores: [String!]!
  $zipcode: String
  $shopperIds: [ID!]
) {
  getActivityList(
    currentFilterStores: $currentFilterStores
    zipcode: $zipcode
    shopperIds: $shopperIds
  ) {
    storeFilters {
      name
      imageUri
      __typename
    }
    upcomingActivities {
      ... on OrderActivity {
        id
        pinCoordinate {
          lat
          lon
          __typename
        }
        activityType
        performerId
        shopperId
        performerBadge
        performerDisplayName
        performerImageUri
        performerActionText
        timeDisplay
        deliveryStartTimestamp
        deliveryEndTimestamp
        timeslotSpotsRemaining
        timeslotSpotsTotal
        storeDisplayName
        storeDisplayImageUri
        pricingDisplayBase
        pricingDisplayMin
        ctaHeaderDisplay
        discountDisplay
      }
    }
    pastActivities {
      ... on OrderActivity {
        id
        pinCoordinate {
          lat
          lon
          __typename
        }
        activityType
        performerId
        shopperId
        performerBadge
        performerDisplayName
        performerImageUri
        performerActionText
        timeDisplay
        deliveryStartTimestamp
        deliveryEndTimestamp
        timeslotSpotsRemaining
        timeslotSpotsTotal
        storeDisplayName
        storeDisplayImageUri
        pricingDisplayBase
        pricingDisplayMin
        ctaHeaderDisplay
        discountDisplay
      }
    }
    neCorner {
      lat
      lon
      __typename
    }
    swCorner {
      lat
      lon
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivityListQueryVariables,
  APITypes.GetActivityListQuery
>;
export const getCartFromActivity = /* GraphQL */ `query GetCartFromActivity($activityId: ID!) {
  getCartFromActivity(activityId: $activityId) {
    cart {
      id
      type
      clientId
      shopper {
        id
        image
        displayName
        isPro
        clientCount
        repeatClientCount
        __typename
      }
      deliveryTimeSlot {
        id
        slotStartIso
        slotEndIso
        slotStart
        slotEnd
        maxOrders
        scheduledOrders
        bufferDuration
        bufferMode
        isAvailable
        inBuffer
        inTimeSlot
        availablePromos {
          id
          type
          code
          displayName
          discountFixed
          discountPercent
          __typename
        }
        __typename
      }
      preTip {
        percent
        fixed
        __typename
      }
      note
      services {
        id
        serviceName
        serviceImage
        listIds
        __typename
      }
      pricingModel {
        version
        description
        flatPm {
          fee
          feeTitle
          display
          __typename
        }
        hourlyPm {
          rate
          billableHours
          minBillableHours
          feeTitle
          display
          __typename
        }
        percentPm {
          percent
          minFee
          feeTitle
          display
          __typename
        }
        preTipPm {
          chosenPercent
          percentages
          defaultPercentagesIndex
          footer
          feeTitle
          display
          fixedGratuityOptions
          defaultFixedGratuityOptionsIndex
          chosenFixedGratuity
          gratuityType
          showPreGratuityByDefault
          allowOptionalGratuity
          showCustomGratuity
          __typename
        }
        clientPlatformPm {
          percent
          feeTitle
          display
          __typename
        }
        suggestedFlatPm {
          fee
          feeWarningThreshold
          percentages
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedPercentPm {
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        suggestedFlatPlusPercentPm {
          fee
          feeWarningThreshold
          percent
          minFee
          percentWarningThreshold
          minFeeWarningThreshold
          gratuityType
          gratuityOptions
          defaultGratuityOptionsIndex
          clientPaysPlatform
          showCustomGratuity
          title
          description
          __typename
        }
        __typename
      }
      paymentMethod {
        id
        brand
        expirationMonth
        expirationYear
        last4
        isDefault
        address {
          id
          addressName
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
          isDefault
          __typename
        }
        __typename
      }
      deliveryAddress {
        id
        addressName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        isDefault
        __typename
      }
      appliedPromos {
        id
        type
        code
        displayName
        discountFixed
        discountPercent
        __typename
      }
      estimatedTotals {
        type
        label
        value
        __typename
      }
      createdOn
      lastUpdated
      __typename
    }
    errors {
      code
      message
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCartFromActivityQueryVariables,
  APITypes.GetCartFromActivityQuery
>;
export const customItemImageSearch = /* GraphQL */ `query CustomItemImageSearch(
  $query: String!
  $storeId: ID!
  $count: Int
  $offset: Int
) {
  customItemImageSearch(
    query: $query
    storeId: $storeId
    count: $count
    offset: $offset
  ) {
    images {
      media {
        ... on MediaImage {
          small {
            width
            height
            path
            mimeType
            __typename
          }
          medium {
            width
            height
            path
            mimeType
            __typename
          }
          large {
            width
            height
            path
            mimeType
            __typename
          }
          xlarge {
            width
            height
            path
            mimeType
            __typename
          }
          full {
            width
            height
            path
            mimeType
            __typename
          }
        }
      }
      sourceUrl
      hostPageUrl
      hostPageName
      __typename
    }
    title
    subTitle
    nextOffset
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomItemImageSearchQueryVariables,
  APITypes.CustomItemImageSearchQuery
>;
export const priceAndEarningsBreakdown = /* GraphQL */ `query PriceAndEarningsBreakdown(
  $shopperId: ID!
  $orderId: ID!
  $deliveryTimestamp: String!
) {
  priceAndEarningsBreakdown(
    shopperId: $shopperId
    orderId: $orderId
    deliveryTimestamp: $deliveryTimestamp
  ) {
    priceBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    earningsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    paymentsBreakdown {
      title
      lineItems {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      final {
        key
        value
        type
        metadata {
          txId
          adjustmentDescription
          paymentUTCTimestamp
          image
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PriceAndEarningsBreakdownQueryVariables,
  APITypes.PriceAndEarningsBreakdownQuery
>;
export const bossForgotPassword = /* GraphQL */ `query BossForgotPassword($phone: String) {
  bossForgotPassword(phone: $phone) {
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BossForgotPasswordQueryVariables,
  APITypes.BossForgotPasswordQuery
>;
export const clientForgotPassword = /* GraphQL */ `query ClientForgotPassword($phone: String) {
  clientForgotPassword(phone: $phone) {
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientForgotPasswordQueryVariables,
  APITypes.ClientForgotPasswordQuery
>;
export const loginClientByOrderId = /* GraphQL */ `query LoginClientByOrderId($id: ID) {
  loginClientByOrderId(id: $id) {
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LoginClientByOrderIdQueryVariables,
  APITypes.LoginClientByOrderIdQuery
>;
export const getBossBuddies = /* GraphQL */ `query GetBossBuddies {
  getBossBuddies {
    bossBuddyProfiles {
      id
      name
      phone
      permissionLevel
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBossBuddiesQueryVariables,
  APITypes.GetBossBuddiesQuery
>;
export const resortClosedDates = /* GraphQL */ `query ResortClosedDates {
  resortClosedDates {
    dates {
      id
      date
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ResortClosedDatesQueryVariables,
  APITypes.ResortClosedDatesQuery
>;
export const GetMapviewData = /* GraphQL */ `query GetMapviewData($zipcodes: [String]!) {
  GetMapviewData(zipcodes: $zipcodes) {
    geoJsons
    swLonLat
    neLonLat
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMapviewDataQueryVariables,
  APITypes.GetMapviewDataQuery
>;
export const resortCatalog = /* GraphQL */ `query ResortCatalog(
  $serviceName: String!
  $breadcrumbs: [String]
  $productId: String
  $searchText: String
  $productIds: [String]
  $categoriesToBlock: [String]
) {
  resortCatalog(
    serviceName: $serviceName
    breadcrumbs: $breadcrumbs
    productId: $productId
    searchText: $searchText
    productIds: $productIds
    categoriesToBlock: $categoriesToBlock
  ) {
    serviceName
    products {
      id
      name
      description
      image
      thumbnail
      options {
        name
        choices
        required
        placeholderText
        __typename
      }
      customizations {
        name
        maxLength
        required
        placeholderText
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ResortCatalogQueryVariables,
  APITypes.ResortCatalogQuery
>;
export const resortConcierge = /* GraphQL */ `query ResortConcierge($id: ID!) {
  resortConcierge(id: $id) {
    id
    firstName
    lastName
    businessName
    phone
    email
    image
    signupTimestamp
    deactivated
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ResortConciergeQueryVariables,
  APITypes.ResortConciergeQuery
>;
export const deliveryImages = /* GraphQL */ `query DeliveryImages($orderId: ID!, $deliveryTimestamp: String!) {
  deliveryImages(orderId: $orderId, deliveryTimestamp: $deliveryTimestamp)
}
` as GeneratedQuery<
  APITypes.DeliveryImagesQueryVariables,
  APITypes.DeliveryImagesQuery
>;
